import React from 'react';

const Icon = ({ className }) => (
    <svg className={className} fill="#000" width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.9997 6.66602C12.3178 6.66602 9.33301 9.59108 9.33301 13.1993C9.33301 17.866 15.9997 25.3327 15.9997 25.3327C15.9997 25.3327 22.6663 17.866 22.6663 13.1993C22.6663 9.59108 19.6816 6.66602 15.9997 6.66602ZM15.9997 15.5327C14.6844 15.5327 13.6187 14.4883 13.6187 13.1993C13.6187 11.9104 14.6844 10.866 15.9997 10.866C17.3149 10.866 18.3806 11.9104 18.3806 13.1993C18.3806 14.4883 17.3149 15.5327 15.9997 15.5327Z" fill="black"/>
    </svg>
);

export default Icon;
